import Seo from "@/components/Seo";

export default function Disclaimer() {
  return (
    <>
      <Seo title="Disclaimer — Fitness Calculator" description="Medical disclaimer. All calculators are for informational purposes only." path="/disclaimer" />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-16 space-y-6">
        <h1 className="text-4xl font-bold tracking-tight">Disclaimer</h1>
        <p className="text-muted-foreground leading-relaxed text-lg">
          The information on this website — including all calculators, results and explanations — is provided for <strong className="text-foreground">informational and educational purposes only</strong>. It is not intended to be a substitute for professional medical advice, diagnosis or treatment.
        </p>
        <p className="text-muted-foreground leading-relaxed">
          Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition, pregnancy, exercise programme or dietary changes. Never disregard professional medical advice or delay in seeking it because of something you have read on this website.
        </p>
        <p className="text-muted-foreground leading-relaxed">
          Calculators involving alcohol consumption (BAC), kidney function (GFR), body composition, eating-disorder indicators and pregnancy provide estimates only and should not be used to make clinical decisions.
        </p>
        <p className="text-muted-foreground leading-relaxed">
          If you think you may have a medical emergency, call your doctor or emergency services immediately.
        </p>
      </div>
    </>
  );
}
